/* eslint-disable react/no-array-index-key */
import React, { Component } from "react"
import PropTypes from "prop-types"

// D3
import { stack } from "d3-shape"
import { scaleBand, scaleLinear } from "d3-scale"

// Utils
import { getColor } from "../utils"

class HorizontalScoreBar extends Component {
  determineColor(d) {
    const { score } = this.props
    const { barColor } = this.props
    if (d.key === "remainder") return "#E9ECF0"
    if (score === 0) return "rgba(238, 91, 105, 0.33)"
    if (!barColor) return getColor(d[0][1])
    return barColor
  }

  render() {
    // Props
    const { svgHeight, margin, containerWidth } = this.props
    const svgWidth = containerWidth
    const { score: providedScore } = this.props
    const GTE_ZERO = providedScore !== null && providedScore >= 0
    const GT_ZERO_OR_NULL = providedScore > 0 || providedScore === null
    const score = GTE_ZERO ? Math.floor(providedScore) : null

    // Data
    const remainder = GT_ZERO_OR_NULL ? 100 - score : 0

    // Dimensions
    const w = svgWidth - margin.left - margin.right
    const h = svgHeight - margin.top - margin.bottom

    // Stacks
    const stacked = stack().keys(["score", "remainder"])
    const series = stacked([{ score, remainder }])

    // Scales
    const y = scaleBand()
      .domain([0, 1])
      .range([h, 0])
      .paddingInner(0.5)

    const x = scaleLinear()
      .domain([0, 100])
      .range([0, w])

    return (
      <svg width={svgWidth} height={svgHeight} className="horizontal-scorebar">
        {series.map((d, i) => (
          <g key={`${d}-${i}`} fill={this.determineColor(d)} className={d.key}>
            <rect
              y={0}
              x={x(d[0][0])}
              width={
                GT_ZERO_OR_NULL || d.key === "remainder"
                  ? x(d[0][1]) - x(d[0][0])
                  : w
              }
              height={y.bandwidth()}
              clipPath={`url(#cp-hsb-${score}-${w})`}
            />
          </g>
        ))}
        <clipPath id={`cp-hsb-${score}-${w}`}>
          <rect x={0} y={0} width={w} height={y.bandwidth()} rx={3} ry={3} />
        </clipPath>
      </svg>
    )
  }
}

export default HorizontalScoreBar

HorizontalScoreBar.propTypes = {
  containerWidth: PropTypes.number,
  barColor: PropTypes.string,
  svgHeight: PropTypes.number,
  margin: PropTypes.shape({
    top: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number
  }),
  score: PropTypes.number
}

HorizontalScoreBar.defaultProps = {
  containerWidth: 150,
  barColor: null,
  svgHeight: 60,
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  score: 0
}
